import { Terminal } from 'xterm';
import * as fit from 'xterm/lib/addons/fit/fit';
import { agentInterceptor } from './core/services/axios';
import { LOCAL_STORAGE_PREFIX } from './local-storage-prefix';

/* @ngInject */
export function configApp($urlRouterProvider, $httpProvider, localStorageServiceProvider, jwtOptionsProvider, $uibTooltipProvider, $compileProvider, cfpLoadingBarProvider) {
  if (process.env.NODE_ENV === 'testing') {
    $compileProvider.debugInfoEnabled(false);
  }

  localStorageServiceProvider.setPrefix(LOCAL_STORAGE_PREFIX);

  jwtOptionsProvider.config({
    tokenGetter: /* @ngInject */ function tokenGetter(LocalStorage) {
      return LocalStorage.getJWT();
    },
  });
  $httpProvider.interceptors.push('jwtInterceptor');
  $httpProvider.interceptors.push('EndpointStatusInterceptor');
  $httpProvider.defaults.headers.post['Content-Type'] = 'application/json';
  $httpProvider.defaults.headers.put['Content-Type'] = 'application/json';
  $httpProvider.defaults.headers.patch['Content-Type'] = 'application/json';

  $httpProvider.interceptors.push(() => ({
    request: agentInterceptor,
  }));

  Terminal.applyAddon(fit);

  $uibTooltipProvider.setTriggers({
    mouseenter: 'mouseleave',
    click: 'click',
    focus: 'blur',
    outsideClick: 'outsideClick',
  });

  cfpLoadingBarProvider.includeSpinner = false;
  cfpLoadingBarProvider.parentSelector = '#loadingbar-placeholder';
  cfpLoadingBarProvider.latencyThreshold = 600;

  // Корневой адрес приложения не соответствует ни одному состоянию: точкой входа
  // служит /auth, который сам решает, куда направить пользователя — на первичную
  // настройку, на экран входа или на главную. Без этих правил открытие «/»
  // попадало в otherwise и показывало страницу «Страница не найдена».
  $urlRouterProvider.when('', '/auth');
  $urlRouterProvider.when('/', '/auth');

  $urlRouterProvider.otherwise(($injector, $location) => {
    const $state = $injector.get('$state');
    $state.go('shbdeployer.error.notFound', { path: $location.path() });
  });
}
